import { render, staticRenderFns } from "./TrainingProfileConfiguration.vue?vue&type=template&id=3d5f5ae8&scoped=true&"
import script from "./TrainingProfileConfiguration.vue?vue&type=script&lang=js&"
export * from "./TrainingProfileConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./TrainingProfileConfiguration.vue?vue&type=style&index=0&id=3d5f5ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f5ae8",
  null
  
)

export default component.exports